import { render, staticRenderFns } from "./PeepsAlertAnimation.vue?vue&type=template&id=44a84028&scoped=true&"
import script from "./PeepsAlertAnimation.vue?vue&type=script&lang=js&"
export * from "./PeepsAlertAnimation.vue?vue&type=script&lang=js&"
import style0 from "./PeepsAlertAnimation.vue?vue&type=style&index=0&id=44a84028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a84028",
  null
  
)

export default component.exports